import { authorize, putRequest } from 'utils/http';
import { Environment } from 'global/environment';

export async function activateUserAPI(userId) {
  return putRequest(`${Environment.BACKEND_API}/admin/users/${userId}/activate`, { }, await authorize());
}
